<template>
  <span>
    <el-link :underline="false" class="chat_link" v-show="userInfo.id" :id="'chat'+userInfo.id" @click.native="chat" type="primary">
      <el-avatar style="margin-right: 5px;" :style="{background: backgroundColor}">{{userInfo.name?(userInfo.name.substr(0,1)):''}}</el-avatar>
      <span class="lable-wrap">
        {{userInfo.name}}
        <i class="el-icon-chat-dot-round" style="margin-left: 5px;"></i>
      </span>
    </el-link>
    <!-- icon="el-icon-chat-dot-round" -->
    <iframe style="display:none;" :src="imSrc"></iframe>
  </span>
</template>
// 人员聊天控件
<script>
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  props: {
    userInfo: {
      type: Object,
      default: function () {
        return { name: "", id: "" };
      },
    },
    backgroundColor: {
      type: String,
      default: "#9184f8",
    },
  },
  data() {
    return {
      imSrc: "",
    };
  },
  methods: {
    chat() {
      if (!this.userInfo.id) return;
      if (this.userInfo.id === cookieUser.userId) {
        this.$message.warning("不能与自己聊天");
        return;
      }
      let url = `RedCoral://IM/?usercode=${cookieUser.account}&users=${this.userInfo.id}&chatType=0`;
      window.protocolCheck(url, () => {
        this.$message.warning("协议未注册");
      });
      this.imSrc = url;
    },
  },
};
</script>

<style lang="scss" scoped>
  .chat_link {
    font-size: 16px !important;
    /deep/ .el-link--inner {
      display: contents;
    }
    /deep/ .el-avatar {
      background-color: #9184f8;
      width: 30px;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
    }
    /deep/.lable-wrap {
      background-color: #fff;
      padding: 4px 10px;
      border-radius: 2px;
    }
  }
</style>